import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { AssessmentService } from 'src/app/core/service/assessment.service';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { sortBy } from 'lodash';
import { Dictionary } from 'src/app/core/model/dictionary';

@Component({
  standalone: false,
  selector: 'app-formly-field-multi-select',
  templateUrl: './formly-field-multi-select.component.html',
  styleUrls: ['./formly-field-multi-select.component.scss']
})
export class FormlyFieldMultiSelectComponent extends FieldType implements OnInit
{
  public dictionary = undefined;
  public searchTerm = '';
  public filtered: any = [];
  public virtualDropdown: any = {
    itemHeight: 30
  };

  constructor(
    private assessmentService: AssessmentService,
    private dictionaryService: DictionaryService,
    private messageHandlerService: MessageHandlerService)
  {
    super();
  }

  public ngOnInit(): void
  {
    this.ensureArrayControlValue();
    this.assessmentService.runAfterFormlyFieldsAttach(() => this.initializeOptions(), 1);
  }

  public filterDictionary(filter: string): void
  {
    this.searchTerm = filter;
    this.filtered = this.dictionary
      .filter((v: Dictionary) => v.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public filterText(filter: string, options: []): void
  {
    this.searchTerm = filter;
    this.filtered = options
      .filter((v: any) => v.label.toLowerCase().includes(filter.toLowerCase()));
  }

  private initializeOptions(): void
  {
    this.dictionary = undefined;
    if (!this.field?.templateOptions)
    {
      return;
    }

    if (this.field.templateOptions.codeSetId)
    {
      this.dictionaryService.getCachedCodesByCodeSetId(this.field.templateOptions.codeSetId).subscribe({
        next: (data) =>
        {
          this.dictionary = sortBy(data, ['displayName']);
          // Must call set value to make sure the display name is shown
          this.formControl.setValue(this.formControl.value);
          this.formControl.updateValueAndValidity();
          this.filterDictionary('');
        },
        error: (error) =>
        {
          this.messageHandlerService.displayError(error);
        }
      });
    }
    else
    {
      this.filtered = this.field.templateOptions.options;
      this.filterText('', this.filtered);
    }
  }

  private ensureArrayControlValue(): void
  {
    if (!this.formControl)
    {
      return;
    }

    const current = this.formControl.value;
    const normalized = this.assessmentService.normalizeFormControlValue(this.field, current);
    if (this.assessmentService.isValidDefaultValue(this.field, normalized))
    {
      if (current !== normalized)
      {
        this.formControl.setValue(normalized, { emitEvent: false });
      }

      return;
    }

    if (current !== null && current !== undefined && !(Array.isArray(current) && current.length === 0))
    {
      this.formControl.setValue(this.assessmentService.getSafeEmptyControlValue(this.field), { emitEvent: false });
    }
  }
}
